import Cookies from "js-cookie";
import isClientSide from "./isClientSide";

const getToken = async () => {
  if (isClientSide()) {
    const authenticated = Cookies.get("authenticated");
    if (authenticated) {
      return Promise.resolve(authenticated === "true");
    }
  }
  return Promise.resolve(true);
};

const getMockAuth = {
  getTokenIfAuthenticated: getToken,
  authenticate: getToken,
  getUser: () =>
    Promise.resolve({
      email: "test@test.com",
      name: "Test",
      "https://www.johnlewis.com/auth/customerId": "6c03b20eeae04370b88e6e0d9109d2c5",
    }),
};

const Auth0 = () => {
  if (isClientSide()) {
    if (process.env.NEXT_PUBLIC_ENVIRONMENT_NAME === "stubs") {
      window.auth0 = getMockAuth;
    }
    return window.auth0;
  }
  return null;
};

export default Auth0;
